import { createApi } from '@reduxjs/toolkit/query/react';
import Outcome from 'models/ValueProposition/Outcome';
import { axiosBaseQuery } from 'services/api';
import { byId } from 'store/utils/sortFunctions';

const OUTCOME_TAG = 'ValuePropositionOutcome';

// API slice for Value Proposition / Outcomes
export const valuePropositionOutcomesApi = createApi({
  reducerPath: 'valuePropositionOutcomesApi',
  baseQuery: axiosBaseQuery(),
  tagTypes: [OUTCOME_TAG],
  endpoints: builder => ({
    listOutcomes: builder.query({
      query: ({ project, product, segment }) => ({
        url: `/api/projects/${project}/products/${product}/segments/${segment}/outcomes/`,
      }),
      transformResponse: response =>
        Array.isArray(response) ? response.map(outcome => new Outcome(outcome)).sort(byId) : [],
      providesTags: [OUTCOME_TAG],
    }),

    fetchSegmentOutcomes: builder.query({
      query: ({ projectId, productId, segmentIds = [] }) => ({
        url: `/api/projects/${projectId}/products/${productId}/outcomes/?segment=${segmentIds.join(',')}`,
      }),
      transformResponse: response =>
        Array.isArray(response) ? response.map(outcome => new Outcome(outcome)).sort(byId) : [],
      providesTags: [OUTCOME_TAG],
    }),

    createOutcome: builder.mutation({
      query: ({ project, product, segment, ...data }) => ({
        url: `/api/projects/${project}/products/${product}/segments/${segment}/outcomes/`,
        method: 'POST',
        data,
      }),
      invalidatesTags: [OUTCOME_TAG],
      transformResponse: response => new Outcome(response),
    }),

    updateOutcome: builder.mutation({
      query: ({ project, product, segment, outcomeId, ...data }) => ({
        url: `/api/projects/${project}/products/${product}/segments/${segment}/outcomes/${outcomeId}/`,
        method: 'PATCH',
        data,
      }),
      invalidatesTags: [OUTCOME_TAG],
      transformResponse: response => new Outcome(response),
    }),

    deleteOutcome: builder.mutation({
      query: ({ project, product, segment, outcomeId }) => ({
        url: `/api/projects/${project}/products/${product}/segments/${segment}/outcomes/${outcomeId}/`,
        method: 'DELETE',
      }),
      invalidatesTags: [OUTCOME_TAG],
    }),
  }),
});

export const {
  useListOutcomesQuery,
  useCreateOutcomeMutation,
  useUpdateOutcomeMutation,
  useDeleteOutcomeMutation,
  useFetchSegmentOutcomesQuery,
} = valuePropositionOutcomesApi;
